import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Box, Heading } from '@components/common';
import { MobileContainer } from '@containers/layout';
import SelectorButton from '@components/SelectorButton';
import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import { AppSelectors } from '@redux/AppRedux';
import { FREQUENCIES, BOOKING_STAGE } from '@services/minte';

const ButtonWrapper = styled(SelectorButton)`
  width: 164px;
  height: 164px;
  flex: unset;
`;

function SubscriptionEmpty(props) {
  const { selectedFrequency, frequencyData, setFrequency, onSubmit } = props;

  const frequency = FREQUENCIES.REGULARLY;
  const data = frequencyData[frequency];
  const { icon } = data;

  return (
    <MobileContainer>
      <Heading px={2} mb={4} mt={[0, 6]}>
        You do not have a routine service cycle scheduled, would you like to
        book one?
      </Heading>

      <Box px={2} display="flex" flexDirection="row" justifyContent="center">
        <ButtonWrapper
          key="subs-empty"
          selected={frequency === selectedFrequency}
          title="Book package"
          icon={icon}
          iconColor="gold"
          onClick={() => {
            setFrequency(frequency);
            onSubmit();
          }}
        />
      </Box>
    </MobileContainer>
  );
}

SubscriptionEmpty.propTypes = {
  selectedFrequency: PropTypes.string,
  frequencyData: PropTypes.object,
  setFrequency: PropTypes.func,
  onSubmit: PropTypes.func.isRequired
};

const mapStatesToProps = state => ({
  selectedFrequency: BookingSelectors.selectFrequency(state),
  frequencyData: AppSelectors.selectFrequencyData(state)
});

const mapDispatchToProps = dispatch => ({
  setFrequency: frequency => {
    dispatch(BookingActions.setBookingFrequency(frequency));
    dispatch(BookingActions.setBookingStep(BOOKING_STAGE.SERVICE_TYPE));
  }
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(SubscriptionEmpty);
